import { useEffect } from "react"
import { useAsyncReducer } from "../../../hooks/useAsyncReducer"
import { fetchUsers, fetchUserDetail } from "../../../actions/manage"
import { manageReducer, manageInitialState } from "../../../reducers/manage"
import { useAuth } from "../../../hooks/useAuth"
import { useStatus } from "../../../hooks/useStatus"
import { useAsyncModal } from "../../../hooks/useAsyncModal"
import { useSyncModal } from "../../../hooks/useSyncModal"
import { InsideContainer } from "../../containers/InsideContainer"
import { Header } from "../../extras/Header"
import { Loading } from "../../static/Loading"
import { EmptyMessage } from "../../static/Messages"
import { CreateUser, EditUser, RemoveUser, UserDetails } from "../../views/Manage"

const permissionsLabel = (p) => { switch(p) { case 1: return 'Administrador'; case 2: return 'Moderador'; default: return 'Componente' } }

const UserIcon = ({ u }) => {
    if (u.expires && u.expires > 0)
        return <span uk-tooltip="title: Usuario con uso limitado temporalmente; pos: bottom"><i className="fas fa-2x fa-clock" style={{color: '#af0427'}}></i></span>
    if (u.type === '1')
        return <span uk-tooltip="title: Usuario menor de 18 años con autorización para el uso; pos: bottom"><i className="fas fa-2x fa-user-circle" style={{color: '#e16921'}}></i></span>
    if (u.type === '2')
        return <span uk-tooltip="title: Usuario menor de 18 años con supervisión de un tutor legal; pos: bottom"><i className="fas fa-2x fa-user-circle" style={{color: '#1a8a43'}}></i></span>
    return <span uk-tooltip="title: Usuario mayor de edad; pos: bottom"><i className="fa fa-2x fa-user-circle" style={{color: '#1e87f0'}}></i></span>
}

const UserRow = ({ elem: u, eventHandlers, currentUser }) => (
    <tr onClick={() => eventHandlers.onInfo(u.user)} style={{cursor: 'pointer'}}>
        <td className="uk-text-center">
            <UserIcon u={u}/>
        </td>
        <td><span className="username">{u.surnames}, {u.name}</span></td>
        <td>{u.instrument || '—'}</td>
        <td>{u.user}</td>
        <td>{u.active ? <span className="ok">Activo</span> : <span className="not om-blinking">Inactivo</span>}</td>
        <td>{permissionsLabel(u.permissions)}</td>
        <td>
            <button className="uk-button uk-button-secondary" uk-tooltip="title: Editar; pos: bottom" onClick={(e) => {e.stopPropagation(); eventHandlers.onEdit(u.user)}}><i className="fas fa-user-edit"></i></button>
            {currentUser !== u.user && <button className="uk-button uk-button-danger" uk-tooltip="title: Eliminar; pos: bottom" onClick={(e) => {e.stopPropagation(); eventHandlers.onRemove(u.user)}}><i className="fas fa-user-minus"></i></button>}
        </td>
    </tr>
)

export const ManageView = () => {
    const [{ loadStatus }, handleStatus] = useStatus()
    const [loading, state, dispatch] = useAsyncReducer(manageReducer, manageInitialState, handleStatus)
    const [user] = useAuth()

    useEffect(() => {
        if(!loadStatus)
            dispatch(fetchUsers(user.token))
    //eslint-disable-next-line
    }, [loadStatus])

    const [open] = useSyncModal()
    const [,setInfoId] = useAsyncModal('user', fetchUserDetail, UserDetails.Body, UserDetails.Header)

    const handleAddUser = () => open(CreateUser.Header, CreateUser.Body)
    const handleEdit = (id) => open(EditUser.Header, EditUser.Body, id)
    const handleRemove = (id) => open(RemoveUser.Header, RemoveUser.Body, id)
    const handleInfo = (id) => setInfoId(id)

    const eventHandlers = { onEdit: handleEdit, onRemove: handleRemove, onInfo: handleInfo }

    return(
        <InsideContainer reducerContext={[loading, state, dispatch, user]} grid={false}>
            <div className="om-padding-remove@s uk-container">
                <Header buttonIcon="fas fa-user-plus" buttonText="Añadir Usuario" onClick={handleAddUser}>
                    <i className="fas fa-1x fa-users-cog"></i> Gestión
                </Header>
                {state.error ? <EmptyMessage message={state.error}/> :
                loading && !state.users ? <Loading large={false}/> :
                !state.users || state.users.length === 0 ? <EmptyMessage message="No se han encontrado usuarios"/> :
                <table className="uk-table uk-table-hover uk-table-middle uk-table-divider">
                    <thead>
                    <tr>
                        <th className="uk-text-center">Tipo Usuario</th>
                        <th className="uk-width-auto">Apellidos, Nombre</th>
                        <th className="uk-width-auto">Instrumento</th>
                        <th className="uk-width-auto">Usuario</th>
                        <th className="uk-width-auto">Estado</th>
                        <th className="uk-width-auto">Privilegios</th>
                        <th className="uk-width-auto">Opciones</th>
                    </tr>
                    </thead>
                    <tbody id="table">
                        {state.users.map((u, i) => <UserRow key={i} elem={u} eventHandlers={eventHandlers} currentUser={user.username}/>)}
                    </tbody>
                </table>}
                <p className="uk-text-lead uk-text-justify hide-s"><b>RECUERDA</b>: Para obtener información sobre un usuario haga click en su nombre y apellidos.</p>
            </div>
        </InsideContainer>
    )
}